import React, { useContext, useEffect, useRef, useState } from 'react'
import { Grid, useTheme } from "@mui/material";
import { useFormContext } from '../Context/Context';
import { useLocation } from 'react-router-dom';
import { useInputValues } from '../Context/InputValuesContext';
import { useErrorContext } from '../Context/ErrorContext';
import { useReadOnly } from '../Context/ReadOnlyContext';
import { FinalValuesContext } from '../Context/FinalValuesContext';
import ConvertTitle from './ConvertTitle';
import { fillPhoneInputValue } from './Phone/phoneHelpers';
import PhoneHeaderInput from './Phone/PhoneHeaderInput';
import PhoneNumberInput from './Phone/PhoneNumberInput';
import PhoneSubLabelInput from './Phone/PhoneSubLabelInput';

const Phone = ({ id, header }) => {
  const location = useLocation();
  const currentPage = location.pathname;

  const { drawerData } = useFormContext();
  const existingComponentIndex = drawerData.findIndex(component => component.id === id);
  const { inputValues } = useInputValues();
  const { setMistake } = useErrorContext();
  const { readOnly } = useReadOnly();
  const { finalSelectValues } = useContext(FinalValuesContext);

  const titleIndex = finalSelectValues.findIndex(item => item.name === "FieldCondition");
  const title = ConvertTitle({ title: finalSelectValues[titleIndex]?.value });
  const dataIndex = drawerData.findIndex(item => item.title === title);
  const dataCondition = drawerData[dataIndex]?.state.readOnly;

  const switchHeader = header || drawerData[existingComponentIndex]?.state.phoneValue || "شماره تلفن";
  const switchSubHeader = drawerData[existingComponentIndex]?.state.alertValue || "لطفا یک شماره تلفن معتبر وارد کنید.";
  const isReadOnly = currentPage.startsWith('/publish') || currentPage.startsWith("/card-form/publish") || currentPage.startsWith("/user/fill-form/");

  const [phoneValue, setPhoneValue] = useState(switchHeader);
  const [phoneInput, setPhoneInput] = useState(drawerData[existingComponentIndex]?.state.mainPhoneInput);
  const [alertValue, setAlertValue] = useState(switchSubHeader);
  const [border, setBorder] = useState(false);
  const [error, setError] = useState('');
  const [condition, setCondition] = useState(false);

  const gridRef = useRef(null);
  const theme = useTheme();
  const HeadingColor = theme.palette.blue[700];

  const handleCondition = () => {
    if (currentPage === '/publish') {
      setCondition(readOnly || dataCondition ? title === 'Phone' : false);
    } else {
      setCondition(false);
    }
  };

  const handlePhoneInputChange = (e) => {
    const value = e.target.value;
    setPhoneInput(value);

    const isNonNumeric = isNaN(value);
    const startsWith09 = value.startsWith('09');
    const isLength11 = value.length === 11;

    if (isNonNumeric) {
      const idx = inputValues.findIndex(item => item.name === "ThisFieldCanOnlyContainNumericValues");
      if (idx !== -1) {
        setError(inputValues[idx].value);
        setMistake(true);
      }
    } else if (!startsWith09) {
      setError('شماره تلفن باید با 09 شروع شود');
    } else if (!isLength11) {
      setError('شماره تلفن باید 11 رقم باشد');
    } else {
      setError('');
      setMistake(false);
    }
  };

  useEffect(() => {
    fillPhoneInputValue({
      drawerData,
      index: existingComponentIndex,
      values: { phoneValue, phoneInput, alertValue },
      readOnly
    });
  }, [id, phoneInput, phoneValue, alertValue]);

  useEffect(() => {
    const handleClick = (e) => {
      if (gridRef.current && !gridRef.current.contains(e.target)) {
        setBorder(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => {
    handleCondition();
  }, [finalSelectValues, readOnly]);

  return (
    <Grid
      mb={currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '28px' : '50px'}
      p={drawerData.length > 0 ? (currentPage.startsWith('/build') || currentPage.startsWith('/publish') || currentPage.startsWith('/user/fill-form') ? '12px 10px' : { xs: '12px', md: '24px' }) : '0px'}
      borderRadius="3px"
      width="100%"
      mx={currentPage === '/build' || currentPage === '/publish' ? '4px' : '0px'}
      ref={gridRef}
      onClick={() => setBorder(true)}
      border={border && drawerData.length > 0 && drawerData[existingComponentIndex] && !isReadOnly ? '2px solid #0293e2' : '2px solid transparent'}
    >
      <Grid pb="16px">
        <PhoneHeaderInput
          value={phoneValue}
          onChange={(e) => setPhoneValue(e.target.value)}
          onFocus={(e) => e.target.select()}
          readOnly={isReadOnly || condition}
          color={HeadingColor}
        />
      </Grid>
      <Grid pb="4px">
        <PhoneNumberInput
          value={phoneInput}
          onChange={handlePhoneInputChange}
          error={error}
          readOnly={condition}
          color={HeadingColor}
        />
      </Grid>
      <Grid>
        <PhoneSubLabelInput
          value={alertValue}
          onChange={(e) => setAlertValue(e.target.value)}
          readOnly={isReadOnly || condition}
        />
      </Grid>
    </Grid>
  );
};

export default Phone;